import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './ProjectCard.css';
import { LuFactory } from "react-icons/lu";
import { FaHardHat } from "react-icons/fa";
import { GrCloudComputer } from "react-icons/gr";
import { SiClevercloud } from "react-icons/si";




// import ProjectData from './ProjectData.js';
// import logo from '../assets/logoBrain.svg'


function ProjectCard({ project, projectId, onShowDetails }) {

  const getProjectIcon = (id) => {
    switch(id) {
        case 'project1':
            return (
            <div className="flex items-center text-5xl text-white">
                <LuFactory />
            </div>
            );
        case 'project2':
            return (
            <div className="flex items-center text-5xl text-white">
                <FaHardHat />
            </div>
            );
        case 'project3':
            return (
            <div className="flex items-center text-5xl text-white">
                <GrCloudComputer />
            </div>
            );
        case 'project4':
            return (
            <div className="flex items-center text-5xl text-white">
                <SiClevercloud  />
            </div>
            );
        case 'project5':
            return (
            <div className="flex items-center text-5xl text-white">
                <SiClevercloud  />
            </div>
            );
        case 'project6':
            return (
            <div className="flex items-center text-5xl text-white">
                <GrCloudComputer />
            </div>
            );
        default:
            return (
                <svg className="w-16 h-16 text-white opacity-80" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
            );
    }
  };

//   const getProjectIcon = (id) => {
//     return (
//         <div className="flex items-center text-lg text-white-500">
//             {project.icon}
//         </div>
//     );
//   };

  const getGradientClass = (id) => {
    switch(id) {
        case 'Industrial Energy': return 'bg-gradient-to-br from-blue-500 to-blue-700';
        case 'Enterprise Software': return 'bg-gradient-to-br from-emerald-500 to-emerald-700';
        case 'Digital Transformation': return 'bg-gradient-to-br from-purple-500 to-purple-700';
        default: return 'bg-gradient-to-br from-yellow-500 to-yellow-700';
    }
  };

  const getStatusBadge = (id) => {
    if (id === 'project3') {
        return (
            // <div className="flex items-center text-sm text-orange-500">
            //     <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            //         <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"></path>
            //     </svg>
            //     65% Complete
            // </div>
        <div className="flex items-center text-sm text-gray-500">
            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
            </svg>
            Completed
        </div>
        );
    }
    return (
        <div className="flex items-center text-sm text-gray-500">
            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
            </svg>
            Completed
        </div>
    );
    };

  return (
    <div className="project-card bg-white rounded-2xl overflow-hidden shadow-lg fade-in visible">
        <div className={`h-48 ${getGradientClass(project.tag)} relative overflow-hidden`}>
            <div className="absolute inset-0 flex items-center justify-center">
                {getProjectIcon(projectId)}
            </div>
            <div className="absolute top-4 left-4 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1 w-fit">
                <span className="text-white text-sm font-medium">
                    {project.tag}
                </span>
            </div>
        </div>
        <div className="p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-2">{project.title}</h3>
            <p className="text-gray-600 mb-4">{project.overview.substring(0, 120)}...</p>
            <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-none text-sm w-fit">{project.metrics.budget} Budget</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-none text-sm w-fit">{project.metrics.timeline}</span>
                <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-none text-sm w-fit">{project.metrics.team}</span>
            </div>
            <div className="flex justify-between items-center">
                <button 
                    onClick={() => onShowDetails(projectId)}
                    className="text-emerald-600 hover:text-emerald-800 font-semibold"
                >
                    View Details
                </button>
                {getStatusBadge(projectId)}
            </div>
        </div>
    </div>
  );
}

export default ProjectCard;